$('.hover-preview .swiper-slide').on('mouseenter', function () {
    $(this).parent().css('min-height', this.clientHeight)
    $(this).addClass('hover')
}).on('mouseleave', function () {
    $(this).parent().css('min-height', '')
    $(this).removeClass('hover')
})
